export const operationAtomicEnum = {
    remove: "remove",
    add: "add",
    update: "update"
};